import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import { Dropdown } from 'react-bootstrap';
import Config from '../config/Config';
import '../css/DppDropdownMenu.css'; // Import your CSS

const DppDropdownMenu = ({ items, onSelect }) => {
  const { mainColor, secondaryColor } = Config.appearance;

  return (
    <Dropdown.Menu
      align="end"
      className="dpp-dropdown-menu"
      style={{
        '--dpp-main-color': mainColor,
        '--dpp-secondary-color': secondaryColor,
      }}
    >
      {items.map((item, index) => {
        if (item.type === 'divider') {
          return <div key={index} className="dpp-dropdown-divider" />;
        }

        const dropdownItem = (
          <Dropdown.Item
            key={index}
            as={item.link ? 'div' : 'button'}
            onClick={() => !item.link && onSelect(item.action)}
            className="dpp-dropdown-item"
          >
            {item.icon && <item.icon />}
            {item.label}
          </Dropdown.Item>
        );

        return item.link ? (
          <Link key={index} to={item.link} style={{ textDecoration: 'none' }}>
            {dropdownItem}
          </Link>
        ) : (
          dropdownItem
        );
      })}
    </Dropdown.Menu>
  );
};

export default DppDropdownMenu;
